






















































































import { defineComponent, ref, onMounted, computed } from '@vue/composition-api'
import {
  mdiCancel,
  mdiCheckCircleOutline,
  mdiDotsVertical,
  mdiFilterVariantMinus,
  mdiPencilOutline,
  mdiPlus,
  mdiViewListOutline,
} from '@mdi/js'

// Components
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import PaginationFooter from '@shared/components/PaginationFooter.vue'
import ReciboFiltro from '../components/ReciboFiltro.vue'

import { IResponseElement, ReciboFiltroModel, ReciboInterface, Pagination } from '@/models'

import { formatISODate, formatTime } from '@core/utils/filter'
import useAppConfig from '@core/@app-config/useAppConfig'
import useReciboEndpoint from '../composables/useReciboEndpoint'

export default defineComponent({
  components: {
    PaginationSelect,
    PaginationFooter,
    ReciboFiltro,
  },
  setup() {
    const recibos = ref<ReciboInterface[]>([])
    const isFilterPanelActive = ref(false)
    const filtro = ref(new ReciboFiltroModel())
    const pagination = ref(new Pagination())
    const { isLoading } = useAppConfig()
    const { find } = useReciboEndpoint()

    onMounted(() => {
      obtenerRecibos(filtro.value)
    })

    const obtenerRecibos = async (filter: ReciboFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await find(params)

      if (ok) {
        actualizarPaginacion(response as IResponseElement<ReciboInterface>)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<ReciboInterface>) => {
      recibos.value = response.elements
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    return {
      filterDate: computed(() => (ISODate: string | null) => formatISODate(ISODate)),
      formatTime: computed(() => (ISODate: string | null) => formatTime(ISODate)),
      recibos,
      filtro,
      isFilterPanelActive,
      isLoading,
      obtenerRecibos,
      pagination,
      icons: {
        mdiCancel,
        mdiCheckCircleOutline,
        mdiDotsVertical,
        mdiFilterVariantMinus,
        mdiPencilOutline,
        mdiPlus,
        mdiViewListOutline,
      },
    }
  },
})
